// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { containsOnlySemicolons } from '../format'

const parseCsvString = (csvString: string) => {
  const parsedCSVRow = csvString.trim().toLowerCase().split(/\r?\n/)
  const parsedCSVWithoutEmptyLines = parsedCSVRow.filter((line) => !containsOnlySemicolons(line))
  return parsedCSVWithoutEmptyLines.map((line) => line.split(';'))
}
export { parseCsvString }
